export enum RugbyLeagueTackleMadeAttribute {
  One = 3012,
  Two = 3013,
  Three = 3014,
  Four = 3015,
  Five = 3016,
  Six = 3017,
}
